import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WordRecallComp from "../components/WordRecallComp";

function WordRecall() {
  return (
    <>
      <Navbar />
      <WordRecallComp />
      <Footer />
    </>
  );
}

export default WordRecall;
